import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdminListingList from "./admin-listing-list/admin-listing-list";
import AdminListingDetails from "./admin-listing-details/admin-listing-details";

const Listing = () => {
  return (
    <Switch>
      <Route exact path="/listing">
        <AdminListingList />
      </Route>
      <Route path="/listing/:applicationId">
        <AdminListingDetails />
      </Route>
    </Switch>
  )
}

export default Listing;
